var _marker, _marker2, _marker3, _marker4, _marker5, _marker6, _marker7, _marker8, _rect, _rect2, _text, _text2, _line, _rect3, _text3, _rect4, _text4, _rect5, _text5, _text6, _line2, _rect6, _text7, _line3, _circle, _text8, _circle2, _text9, _circle3, _text0, _text1, _line4, _rect7, _text10, _text11, _rect8, _text12, _text13, _line5, _text14, _line6, _text15, _line7, _text16, _rect9, _circle4, _circle5, _text17, _line8, _circle6, _text18, _circle7, _text19, _circle8, _text20, _circle9, _text21, _circle0, _text22, _line9, _text23, _line0, _text24, _rect0, _text25, _text26, _rect1, _text27, _rect10, _text28, _text29, _path, _text30, _path2, _rect11, _text31, _line1, _circle1, _text32, _circle10, _text33, _circle11, _text34, _text35, _line10, _rect12, _text36, _text37, _line11, _text38, _rect13, _text39, _text40, _line12, _rect14, _text41, _text42, _line13, _text43, _line14, _text44, _line15, _text45, _line16, _text46, _line17, _text47, _line18, _text48, _line19, _text49, _rect15, _text50;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChurnPipeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1100,
    height: 740,
    viewBox: "0 0 1100 740",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "mc",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#06B6D4"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "mg",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#22c55e"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "mv",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#a78bfa"
  }))), _marker4 || (_marker4 = /*#__PURE__*/React.createElement("marker", {
    id: "mt",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#10b981"
  }))), _marker5 || (_marker5 = /*#__PURE__*/React.createElement("marker", {
    id: "mb",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#7dd3fc"
  }))), _marker6 || (_marker6 = /*#__PURE__*/React.createElement("marker", {
    id: "mfr",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#F59E0B"
  }))), _marker7 || (_marker7 = /*#__PURE__*/React.createElement("marker", {
    id: "mfl",
    markerWidth: 8,
    markerHeight: 8,
    refX: 0,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L8,6 L0,3 z",
    fill: "#F59E0B"
  }))), _marker8 || (_marker8 = /*#__PURE__*/React.createElement("marker", {
    id: "mvi",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#8b5cf6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgc",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c1628"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#060c14"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1100,
    height: 740,
    fill: "url(#bgc)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1100,
    height: 740,
    fill: "none",
    rx: 12,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 36,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 17,
    fontWeight: 700,
    letterSpacing: -0.3
  }, "Insurance Churn Prediction Pipeline")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 55,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 10
  }, "XGBoost \xB7 Azure Machine Learning \xB7 Azure Storage \xB7 Azure Function \xB7 CRM Integration \xB7 Power BI")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 68,
    x2: 1060,
    y2: 68,
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 76,
    width: 490,
    height: 604,
    rx: 8,
    fill: "rgba(34,197,94,0.02)",
    stroke: "#22c55e",
    strokeWidth: 1,
    strokeDasharray: "6,4"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 271,
    y: 92,
    textAnchor: "middle",
    fill: "#166534",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: 0.6
  }, "TRAINING &amp; DEPLOYMENT")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 80,
    width: 206,
    height: 26,
    rx: 4,
    fill: "rgba(245,158,11,0.05)",
    stroke: "#F59E0B",
    strokeWidth: 1,
    strokeDasharray: "4,3"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 97,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 8.5
  }, "\u27F3  Periodic Schedule \xB7 automated retraining")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 118,
    width: 180,
    height: 50,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 138,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 700
  }, "Historical Data")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 153,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "client database \xB7 behavioural records")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 168,
    x2: 170,
    y2: 192,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#mg)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 194,
    width: 240,
    height: 96,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 214,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 11,
    fontWeight: 700
  }, "Feature Engineering")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 222,
    x2: 277,
    y2: 222,
    stroke: "rgba(34,197,94,0.12)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 235,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 239,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Service usage &amp; online activity")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 253,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 257,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Payment delays &amp; missed payments")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 271,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 275,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Support interactions \xB7 demographics")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 284,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7.5
  }, "null handling \xB7 encoding \xB7 temporal train/test split")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 290,
    x2: 170,
    y2: 310,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#mg)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 312,
    width: 180,
    height: 52,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 332,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 11,
    fontWeight: 700
  }, "XGBoost Training")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 347,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "\u27F3 periodic runs \xB7 hyperparameter tuning")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 312,
    width: 174,
    height: 52,
    rx: 6,
    fill: "rgba(245,158,11,0.05)",
    stroke: "#F59E0B",
    strokeWidth: 1.5
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 332,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 11,
    fontWeight: 700
  }, "Azure DevOps")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 347,
    textAnchor: "middle",
    fill: "#78530a",
    fontSize: 9
  }, "versioned training scripts")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 262,
    y1: 338,
    x2: 307,
    y2: 338,
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    markerStart: "url(#mfl)",
    markerEnd: "url(#mfr)"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 284,
    y: 331,
    textAnchor: "middle",
    fill: "#78530a",
    fontSize: 7.5
  }, "commit")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 364,
    x2: 170,
    y2: 386,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#mv)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 378,
    fill: "#4c3a8c",
    fontSize: 7.5
  }, "run")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 395,
    y1: 364,
    x2: 395,
    y2: 386,
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeDasharray: "4,2",
    markerEnd: "url(#mfr)"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 378,
    fill: "#78530a",
    fontSize: 7.5
  }, "scripts")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 388,
    width: 436,
    height: 164,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 388,
    r: 3.5,
    fill: "#a78bfa",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 388,
    r: 3.5,
    fill: "#F59E0B",
    opacity: 0.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 268,
    y: 408,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 12,
    fontWeight: 700
  }, "Azure Machine Learning")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 416,
    x2: 473,
    y2: 416,
    stroke: "rgba(167,139,250,0.12)",
    strokeWidth: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 430,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 434,
    fill: "#cbd5e1",
    fontSize: 9
  }, "\u27F3  Executes periodic training runs via versioned Azure DevOps scripts")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 449,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 453,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Trains XGBoost on refreshed data \xB7 logs experiments automatically")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 468,
    r: 2.5,
    fill: "#fbbf24",
    opacity: 0.8
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 472,
    fill: "#fcd34d",
    fontSize: 9
  }, "Stores model metadata &amp; evaluation metrics per version (model registry)")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 487,
    r: 2.5,
    fill: "#fbbf24",
    opacity: 0.8
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 491,
    fill: "#fcd34d",
    fontSize: 9
  }, "Compares new model vs. production model metrics using stored metadata")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 506,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.8
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 510,
    fill: "#86efac",
    fontSize: 9
  }, "Promotes best-performing model artefact to Azure Storage")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 520,
    x2: 473,
    y2: 520,
    stroke: "rgba(167,139,250,0.08)",
    strokeWidth: 1
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 268,
    y: 533,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7.5
  }, "model registry \xB7 experiment tracking \xB7 automated comparison \xB7 MLflow")), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 552,
    x2: 220,
    y2: 568,
    stroke: "#a78bfa",
    strokeWidth: 2,
    markerEnd: "url(#mv)"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 238,
    y: 562,
    fill: "#4c3a8c",
    fontSize: 7.5
  }, "promotes best model")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 570,
    width: 200,
    height: 52,
    rx: 6,
    fill: "#0a1628",
    stroke: "#7dd3fc",
    strokeWidth: 1.5
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 590,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 11,
    fontWeight: 700
  }, "Azure Storage")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 605,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8.5
  }, "model artefact \xB7 preprocessing pipeline")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 76,
    width: 490,
    height: 604,
    rx: 8,
    fill: "rgba(16,185,129,0.02)",
    stroke: "#10b981",
    strokeWidth: 1,
    strokeDasharray: "6,4"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 829,
    y: 92,
    textAnchor: "middle",
    fill: "#065f46",
    fontSize: 8,
    fontWeight: 600,
    letterSpacing: 0.6
  }, "PRODUCTION SCORING &amp; RETENTION")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 118,
    width: 200,
    height: 50,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 868,
    y: 138,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 700
  }, "Eligible Policies")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 868,
    y: 153,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "client database \xB7 active policies")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 320 596 L 538 596 L 538 308 L 598 308",
    fill: "none",
    stroke: "#7dd3fc",
    strokeWidth: 1.5,
    strokeDasharray: "5,3",
    markerEnd: "url(#mb)"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 554,
    y: 466,
    fill: "#1e4966",
    fontSize: 8,
    transform: "rotate(-90,554,466)"
  }, "loads model")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 868 168 L 868 250 L 718 250 L 718 266",
    fill: "none",
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#mc)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 268,
    width: 240,
    height: 96,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 718,
    y: 288,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 11,
    fontWeight: 700
  }, "Azure Function")), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 611,
    y1: 296,
    x2: 825,
    y2: 296,
    stroke: "rgba(167,139,250,0.12)",
    strokeWidth: 1
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 309,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 625,
    y: 313,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Loads active model from Azure Storage")), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 327,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 625,
    y: 331,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Applies same preprocessing as training")), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 345,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 625,
    y: 349,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Generates churn score 0 \u2013 1 per policy")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 718,
    y: 358,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7.5
  }, "on-demand \xB7 serverless \xB7 writes score to CRM via API")), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 718,
    y1: 364,
    x2: 718,
    y2: 410,
    stroke: "#10b981",
    strokeWidth: 1.5,
    markerEnd: "url(#mt)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 412,
    width: 240,
    height: 52,
    rx: 6,
    fill: "#0a1628",
    stroke: "#10b981",
    strokeWidth: 1.5
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 718,
    y: 432,
    textAnchor: "middle",
    fill: "#34d399",
    fontSize: 11,
    fontWeight: 700
  }, "Insurer's CRM")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 718,
    y: 447,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "score stored \xB7 threshold check \xB7 trigger")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 839,
    y1: 438,
    x2: 857,
    y2: 438,
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    markerEnd: "url(#mfr)"
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 848,
    y: 431,
    textAnchor: "middle",
    fill: "#78530a",
    fontSize: 7.5
  }, "threshold")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 858,
    y: 412,
    width: 196,
    height: 52,
    rx: 6,
    fill: "rgba(245,158,11,0.05)",
    stroke: "#F59E0B",
    strokeWidth: 1.5
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 956,
    y: 432,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 11,
    fontWeight: 700
  }, "Retention Call")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 956,
    y: 447,
    textAnchor: "middle",
    fill: "#78530a",
    fontSize: 9
  }, "personalised script \xB7 prepared agent")), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 718,
    y1: 464,
    x2: 718,
    y2: 504,
    stroke: "#8b5cf6",
    strokeWidth: 1.5,
    markerEnd: "url(#mvi)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 506,
    width: 450,
    height: 52,
    rx: 6,
    fill: "rgba(139,92,246,0.06)",
    stroke: "#8b5cf6",
    strokeWidth: 1.5
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 823,
    y: 526,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontSize: 11,
    fontWeight: 700
  }, "Power BI \xB7 Model Comparison Dashboard")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 823,
    y: 541,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "AUC per version \xB7 group separation \xB7 improvement rate \xB7 policy drill-down \xB7 period &amp; segment filters")), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 710,
    x2: 46,
    y2: 710,
    stroke: "#22c55e",
    strokeWidth: 2
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 714,
    fill: "#475569",
    fontSize: 9
  }, "Training flow")), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 710,
    x2: 160,
    y2: 710,
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 166,
    y: 714,
    fill: "#475569",
    fontSize: 9
  }, "Azure ML \xB7 Function")), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 710,
    x2: 298,
    y2: 710,
    stroke: "#F59E0B",
    strokeWidth: 1.5
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 714,
    fill: "#475569",
    fontSize: 9
  }, "DevOps \xB7 Retention")), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 412,
    y1: 710,
    x2: 432,
    y2: 710,
    stroke: "#7dd3fc",
    strokeWidth: 1.5,
    strokeDasharray: "4,2"
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 438,
    y: 714,
    fill: "#475569",
    fontSize: 9
  }, "Model load (Storage)")), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 556,
    y1: 710,
    x2: 576,
    y2: 710,
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 582,
    y: 714,
    fill: "#475569",
    fontSize: 9
  }, "Eligible policies")), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 710,
    x2: 690,
    y2: 710,
    stroke: "#10b981",
    strokeWidth: 1.5
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 696,
    y: 714,
    fill: "#475569",
    fontSize: 9
  }, "CRM scoring path")), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 710,
    x2: 820,
    y2: 710,
    stroke: "#8b5cf6",
    strokeWidth: 1.5
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 714,
    fill: "#475569",
    fontSize: 9
  }, "Power BI")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 704,
    width: 14,
    height: 10,
    rx: 2,
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 1,
    strokeDasharray: "3,2"
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 714,
    fill: "#475569",
    fontSize: 9
  }, "Periodic")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurnPipeline);
export default __webpack_public_path__ + "static/media/churn-pipeline.e2dbd6e55f255f3ae8e49a98ae7298f4.svg";
export { ForwardRef as ReactComponent };